module.exports = __webpack_public_path__ + "img/login_background.5a9c45f9.jpg";